import { render, staticRenderFns } from "./TencentAiData.vue?vue&type=template&id=7440df96&scoped=true&"
import script from "./TencentAiData.vue?vue&type=script&lang=js&"
export * from "./TencentAiData.vue?vue&type=script&lang=js&"
import style0 from "./TencentAiData.vue?vue&type=style&index=0&id=7440df96&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7440df96",
  null
  
)

export default component.exports